import React from 'react'

type Filter = {
  type: string
  label: string
  remove?: boolean
}

interface FilterPillComponent {
  (props: {
    children: React.ReactNode
    onClick: (Filter) => void
    className: string
    filter: Filter
  }): JSX.Element
}

const FilterPill: FilterPillComponent = ({
  children,
  onClick,
  filter,
  className = ''
}) => {
  return (
    <span
      className={`flex h-9 cursor-pointer items-center whitespace-nowrap rounded-full border border-transparent bg-primary-50 
        px-3 py-1.5 text-sm font-medium text-gray-1100 hover:bg-primary-150 focus:border-primary-300 active:bg-primary-200 ${className}`}
      onClick={() => onClick(filter)}
    >
      {children}
    </span>
  )
}

export default FilterPill
